var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 9.5,
    fill: "white",
    stroke: "#D6E1F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 27.9311C13 23.8148 13 19.702 13 15.5858C13.0145 15.4827 13.029 15.3796 13.0471 15.2729C13.3372 13.3712 14.9362 12.0062 16.9013 12.0027C19.9687 11.9991 23.0398 11.9991 26.1072 12.0027C26.3247 12.0027 26.5423 12.0133 26.7562 12.0524C28.6633 12.3901 29.9868 13.9044 29.994 15.8026C30.0049 19.7696 29.9976 23.7366 29.9976 27.7C29.9976 28.0661 29.9215 28.4145 29.7547 28.7451C29.0513 30.1314 27.1768 30.43 26.0419 29.328C24.5771 27.9062 23.1195 26.4772 21.6547 25.0518C21.604 25.002 21.5532 24.9594 21.5061 24.9132C21.4807 24.9309 21.4698 24.9381 21.4589 24.9452C20.6431 25.7414 19.8273 26.5376 19.0115 27.3339C18.3045 28.0199 17.6156 28.7238 16.8905 29.392C15.6649 30.5224 13.6454 30.0034 13.1269 28.4394C13.0725 28.2759 13.0399 28.1017 13 27.9311Z",
    fill: "#011367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.583a2a82057da127923bd5817c516a21.svg";
export { ForwardRef as ReactComponent };